import { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { internationalListings } from "../data/international";
import "./International.css";

const COUNTRIES = ["All", ...new Set(internationalListings.map(l => l.country))];

export default function International() {
  const [country, setCountry] = useState("All");
  const { t } = useTranslation("international");

  const filtered = country === "All"
    ? internationalListings
    : internationalListings.filter(l => l.country === country);

  const filterLabel = (c) => c === "All" ? t("filter.all") : c;

  return (
    <main className="intl">
      <Helmet>
        <title>International Properties — ProNet Real Estate</title>
        <meta name="description" content="Explore premium international properties in Spain, Thailand, and beyond. Exclusive listings curated by ProNet Real Estate Dubai." />
        <link rel="canonical" href="https://pronet-realestate.com/international" />
        <meta property="og:title" content="International Properties — ProNet Real Estate" />
        <meta property="og:description" content="Explore premium international properties in Spain, Thailand, and beyond. Exclusive listings curated by ProNet Real Estate Dubai." />
        <meta property="og:url" content="https://pronet-realestate.com/international" />
        <meta property="og:type" content="website" />
      </Helmet>

      <section className="intl-hero">
        <div className="container">
          <p className="intl-eyebrow">{t("hero.eyebrow")}</p>
          <h1 className="intl-title">{t("hero.title")} <em>{t("hero.titleEm")}</em></h1>
          <p className="intl-sub">{t("hero.sub")}</p>
        </div>
      </section>

      <div className="container intl-body">
        <div className="intl-filters">
          {COUNTRIES.map(c => (
            <button
              key={c}
              className={`intl-filter-btn ${country === c ? "active" : ""}`}
              onClick={() => setCountry(c)}
            >
              {filterLabel(c)}
            </button>
          ))}
        </div>

        <p className="intl-count">{t("count", { count: filtered.length })}</p>

        <div className="intl-grid">
          {filtered.map(listing => (
            <Link key={listing.id} to={`/international/${listing.slug}`} className="intl-card">
              <div className="intl-card-img">
                <img src={listing.images[0]} alt={listing.title} loading="lazy" />
                <div className="intl-card-overlay" />
                <span className="intl-card-country">{listing.country}</span>
                <div className="intl-card-watermark" />
              </div>
              <div className="intl-card-body">
                <div className="intl-card-price">
                  {new Intl.NumberFormat("de-DE").format(listing.price)} {listing.currency}
                </div>
                <h2 className="intl-card-title">{listing.title}</h2>
                <p className="intl-card-loc">{listing.location}</p>
                <div className="intl-card-meta">
                  <span>{listing.beds} {t("card.bedrooms")}</span>
                  <span className="sep">·</span>
                  <span>{listing.baths} {t("card.bathrooms")}</span>
                  <span className="sep">·</span>
                  <span>{listing.sqm.toLocaleString()} m²</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </main>
  );
}
